import { AnnotationType } from "./EnumTypes";

export class AnnotationModel {
  id: number;
  projectId: number;
  name: string;
  text: string;
  visible: boolean = true;
  lineWidth: number = 2;
  color: string ="#000000";
  font: string;
  source: string;
  annotationType: AnnotationType;

  static map(annotation: any): AnnotationModel{
    var model = new AnnotationModel();
    model.id = annotation.id;
    model.projectId = annotation.projectId;
    model.name = annotation.name;
    model.color = annotation.color;
    model.font = annotation.font;
    model.lineWidth = annotation.lineWidth;
    model.text = annotation.text;
    model.visible = annotation.visible;
    model.source = annotation.source;
    model.annotationType = AnnotationType[annotation.type];
    return model;
  };


  static mapToService(model: AnnotationModel): any{
    var annotation : any = new Object;
    annotation.id = model.id;
    annotation.projectId = model.projectId;
    annotation.name = model.name;
    annotation.color = model.color;
    annotation.font = model.font;
    annotation.lineWidth = model.lineWidth;
    annotation.text = model.text;
    annotation.visible = true;
    annotation.source = model.source;
    annotation.type = model.annotationType;
    return annotation;
  }
}
